import DangerZone from '@/components/account/danger-zone';
import UserAccountInfo from '@/components/account/user-info';
import { Separator } from '@/components/ui/separator';
import { AsyncErrorBoundary } from '@/context/async-error-boundary';
import { useAuthContext } from '@/context/auth-provider';
import { useEffect } from 'react';

const Account = () => {
    const { refetch } = useAuthContext();

    async function onReset() {
        window.location.replace('/account');
    }
    useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className='m-6 border-2 rounded-xl p-0.5 pb-12 shadow-lg space-y-6'>
            <AsyncErrorBoundary
                showCancelButton={false}
                onReset={onReset}>
                <UserAccountInfo />
            </AsyncErrorBoundary>
            <Separator />
            <DangerZone />
        </div>
    );
};
export default Account;
